//Convert images for lab16 from imagine images
//these are the deepfake images of the teammates
const imagesPath = {
  0: "/img/imagine26/deepfakeGenerations/image0.png",
  1: "/img/imagine26/deepfakeGenerations/image1.png",
  2: "/img/imagine26/deepfakeGenerations/image2.png",
  3: "/img/imagine26/deepfakeGenerations/image3.png",
};

export { imagesPath };
